var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modal,
          expression: "modal"
        }
      ],
      attrs: { id: "modal" }
    },
    [
      _c("div", {
        staticClass: "modal__overlay",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _c(_vm.modalName, {
            tag: "component",
            attrs: { meditation: _vm.meditation, recipe: _vm.recipe },
            on: {
              action: _vm.handleAction,
              close: function($event) {
                return _vm.$emit("close")
              },
              changeModal: function($event) {
                return _vm.$emit("changeModal", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }